<template>
<b-modal
    id="formNotes"
    :title="($parent.isAdd?'Add':'Edit') + ' ' + $parent.pageTitle"
    centered
    no-close-on-backdrop
    hide-footer
    size="xl" :visible="true" :no-enforce-focus="true"
    @close="close" 
  >
  <b-card v-if="!$parent.loadingOverlay" no-body class="m-0">
    <validation-observer
      v-slot="{ handleSubmit }" ref="VForm"
    >
      <b-form @submit.prevent="handleSubmit(doSubmitForm())">
        <b-card-body>
          <b-row>
            <b-col lg="8">
              <b-row>
                <b-col lg="12">
                  <b-form-group>
                    <label>Title <span class="text-danger mr5">*</span></label>
                    <b-form-input v-model="row.an_title" placeholder="e.g Title">
                    </b-form-input>
                    <VValidate 
                      name="Title" 
                      v-model="row.an_title" 
                      :rules="mrValidation.an_title" 
                    />
                  </b-form-group>
                </b-col>
                <b-col lg="12">
                  <b-form-group>
                    <label>Content <span class="text-danger mr5">*</span></label>
                    <!--<ckeditor type="full" :value.sync="row.an_content"/>-->
                    <ckeditor v-model="row.an_content" :config="{ removePlugins: 'notification' }"/>
                    <VValidate 
                      name="Content" 
                      v-model="row.an_content" 
                      :rules="mrValidation.an_content" 
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="4">
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label>Creator <span class="text-danger mr5">*</span></label>
                    <b-form-input v-model="row.an_creator" placeholder="e.g Creator">
                    </b-form-input>
                    <VValidate 
                      name="Creator" 
                      v-model="row.an_creator" 
                      :rules="mrValidation.an_creator" 
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <label>Tags <span class="text-black mr5">(Optional)</span></label>
                    <input-tag v-model="row.an_tags"></input-tag>
                    <VValidate 
                      name="Tags" 
                      v-model="row.an_tags" 
                      :rules="mrValidation.an_tags" 
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-footer>
          <b-row>
            <b-col lg="12" class="text-right">
              <button @click="close" type="button" class="btn  btn-rounded  btn-default mr-3">Cancel</button>
              <b-button type="submit" variant="info" class="btn-rounded">Save Changes</b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-form>
    </validation-observer>
  </b-card>
</b-modal>
</template>

<script>
import Vue from 'vue'
import Gen from '@/libs/Gen'
// import CKEditor from '@/components/CKEditor'
import CKEditor from 'ckeditor4-vue'
import $ from 'jquery'
const _ = global._

Vue.use(CKEditor)

export default{
  // components: { ckeditor: CKEditor },
  components: CKEditor,
  props: {
    rowModal: Object,
    pageSlug: String
  },
  data() {
    return {
      row:{},
      mrValidation:{},
      Config:{}
    }
  },
  mounted() {
    this.$parent.loadingOverlay = true
    this.getRow()
  },
  methods:{
    getRow(){
      this.$parent.loadingOverlay = true
      this.row = {}
      let slugs = (this.pageSlug?"/"+this.pageSlug:"")
      Gen.apiRest(
        "/get/"+this.$parent.modulePage+
        slugs, 
        {
          params: Object.assign({}, this.apiParams, {})
        }
      ).then(res=>{
        this.$parent.loadingOverlay = false

        _.forEach(res.data, (v,k)=>{
          this.$set(this, k, v)
        })

        this.$parent.setFocusForm()
        
      }).catch(()=>{
        this.$parent.loadingOverlay = false
      })
    },
    close() {
      this.$emit('update:pageSlug', 'canceled')
      this.$nextTick(() => {
        this.$router.back()
      })
    },
    doSubmitForm(){
      return this.$parent.doSubmit(
          "/do/BoNotes",
          _.assign({type:this.$parent.isAdd?'add':'update'}, {id: (this.pageSlug)}, _.clone(this.row)), 
          (type, resp)=>{
            if(type=='success'){
              this.$emit('update:pageSlug', 'updated')

              if (!this.$parent.isAdd && this.rowModal) {
                if (this.rowModal.an_id === this.row.an_id) {
                  this.$emit('update:rowModal', this.row)
                }
              }

              if(this.isAccountSetting){
                location.reload()
              }else{
                this.$router.push({name:this.$route.name})
              }
            }else{
              if(resp.response.status==422) {
                if((_.values(resp.response.data)[0][0]||"").indexOf('validation')>-1){
                  var msg = ""
                  $.each(Object.keys(resp.response.data),(i,v)=>{
                    msg = msg+" <br/>"+v+" : "+_.values(resp.response.data[v])
                  })
                  return this.$swal("Blocked With Validation!", msg)
                }else{
                  return this.$swal("Sorry, There is something wrong!", _.values(resp.response.data)[0][0])
                }
              }else if(resp.response.status==400){
                return this.$swal({
                  title: resp.response.data.message,
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
              }
            }
          },
          'POST', 'VForm', this.$refs
      )
    }
  }
}
</script>